import { motion, AnimatePresence } from 'framer-motion'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { drawerCreators } from '@/store/ducks/drawer'
import { twMerge } from 'tailwind-merge'

interface DrawerProps {
	children?: React.ReactNode
	className?: string
	disabledOnClose?: boolean
	onClose?: () => void
}

export default function Drawer({
	children,
	className,
	disabledOnClose,
	onClose,
}: DrawerProps) {
	const { opened, drawerInfo } = useAppSelector((state) => state.drawer)
	const dispatch = useAppDispatch()

	async function closeModal() {
		onClose && onClose()
		await dispatch(drawerCreators.closeDrawer())
	}

	return (
		<AnimatePresence>
			{opened && drawerInfo && (
				<motion.div
					className='fixed inset-0 z-40'
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 0.3, ease: 'easeInOut' }}
				>
					<motion.div
						className='absolute inset-0 bg-[#150E1D]/50'
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						transition={{ duration: 0.2, ease: 'easeInOut' }}
						onClick={() => (disabledOnClose ? null : closeModal())}
					/>
					<motion.div
						className={twMerge(
							'absolute inset-y-0 translate-x-10 left-3 right-3 sm:right-4 sm:left-auto shadow-xl overflow-clip top-4 bottom-4 z-50 w-[calc(100%_-_24px)] max-w-[808px] bg-zinc-900 rounded-lg',
							className
						)}
						initial={{ x: '100%' }}
						animate={{ x: 0 }}
						exit={{ x: '100%' }}
						transition={{ duration: 0.3, ease: 'easeInOut' }}
					>
						{children}
					</motion.div>
				</motion.div>
			)}
		</AnimatePresence>
	)
}
